import Vue from "vue";
import VueRouter from "vue-router";
import Register from "../views/register.vue";
import Otp from "../views/otp.vue";
import Home from "../views/home.vue";
import Login from "../views/login.vue";
import Setpassword from "../views/set_password.vue";
import GroupID from "../views/groupID.vue";
import RegistrationSuccess from "../views/registration_success";
import AppHome from "../views/app-home.vue";
import SideMenu from "../views/side-menu.vue";
import SymptomChk from "../views/symptom-chk.vue";
import SymptomChkSuccess from "../views/symptom-chk-success.vue";
import Resources from "../views/resources.vue";
import ForgotPassword from "../views/forgot_password.vue";
import ResetPassword from "../views/reset_password.vue";
import TestResults from "../views/test-results.vue";
import ScheduleChecker from "../views/schedule_checker.vue";
import ChangeAppointment from "../views/change_appointment.vue";
import ViewAppointment from "../views/view_appointment.vue";
import Disclamier from "../views/disclamier.vue";
// TODO: InspireDiagnosticsHealth
import PersonalDetails from "../views/personal-details.vue";
import PreMedicalDetails from "../views/pre-medical-details";
import EditPersonalDetails from "../views/edit_personal_details.vue";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/",
  //   name: "flash_screen",
  //   component: FlasScreen,
  // },
  {
    path: "/home",
    name: "home",
    component: Home,
  },
  {
    path: "/groupID",
    name: "groupID",
    component: GroupID,
  },
  {
    path: "/register",
    name: "register",
    component: Register,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/otp",
    name: "otp",
    component: Otp,
  },
  {
    path: "/set_password",
    name: "set_password",
    component: Setpassword,
  },
  {
    path: "/registration_success",
    name: "registration_success",
    component: RegistrationSuccess,
  },

  {
    path: "/app-home",
    name: "Appointment Home",
    component: AppHome,
  },
  {
    path: "/side-menu",
    name: "Side Menu ",
    component: SideMenu,
  },
  {
    path: "/symptom-chk",
    name: "Symptom Chk",
    component: SymptomChk,
  },
  {
    path: "/symptom-chk-success",
    name: "symptom-chk-success",
    component: SymptomChkSuccess,
  },
  {
    path: "/resources",
    name: "resources",
    component: Resources,
  },
  {
    path: "/forgot_password",
    name: "forgot_password",
    component: ForgotPassword,
  },
  {
    path: "/reset_password",
    name: "reset_password",
    component: ResetPassword,
  },
  {
    path: "/test-results",
    name: "test-results",
    component: TestResults,
  },
  {
    path: "/schedule_checker",
    name: "schedule_checker",
    component: ScheduleChecker,
  },
  {
    path: "/change_appointment",
    name: "change_appointment",
    component: ChangeAppointment,
  },
  {
    path: "/view_appointment",
    name: "view_appointment",
    component: ViewAppointment,
  },
  {
    path: "/disclamier",
    name: "disclamier",
    component: Disclamier,
  },
  // TODO: InspireDiagnosticsHealth
  {
    path: "/personal-details",
    name: "personal-details",
    component: PersonalDetails,
  },
  {
    path: "/pre-medical-details",
    name: "pre-medical-details",
    component: PreMedicalDetails,
  },
  {
    path: "/edit_personal_details",
    name: "edit_personal_details",
    component: EditPersonalDetails,
  },
];

const router = new VueRouter({
  // mode: "history",
  // base: process.env.BASE_URL,
  routes,
});

export default router;
